/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationChannelListEntry } from './NotificationChannelListEntry';
import {
    NotificationChannelListEntryFromJSON,
    NotificationChannelListEntryFromJSONTyped,
    NotificationChannelListEntryToJSON,
    NotificationChannelListEntryToJSONTyped,
} from './NotificationChannelListEntry';
import type { NotificationPreferenceDeliveryScope } from './NotificationPreferenceDeliveryScope';
import {
    NotificationPreferenceDeliveryScopeFromJSON,
    NotificationPreferenceDeliveryScopeFromJSONTyped,
    NotificationPreferenceDeliveryScopeToJSON,
    NotificationPreferenceDeliveryScopeToJSONTyped,
} from './NotificationPreferenceDeliveryScope';
import type { NotificationPreferenceSettings } from './NotificationPreferenceSettings';
import {
    NotificationPreferenceSettingsFromJSON,
    NotificationPreferenceSettingsFromJSONTyped,
    NotificationPreferenceSettingsToJSON,
    NotificationPreferenceSettingsToJSONTyped,
} from './NotificationPreferenceSettings';

/**
 * 
 * @export
 * @interface NotificationPreferenceListEntry
 */
export interface NotificationPreferenceListEntry {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    mandatory_message?: string;
    /**
     * 
     */
    channels?: Array<NotificationChannelListEntry>;
    /**
     * 
     */
    preference_settings?: NotificationPreferenceSettings;
    /**
     * 
     */
    delivery_scopes?: Array<NotificationPreferenceDeliveryScope>;
}

/**
 * Check if a given object implements the NotificationPreferenceListEntry interface.
 */
export function instanceOfNotificationPreferenceListEntry(value: object): value is NotificationPreferenceListEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function NotificationPreferenceListEntryFromJSON(json: any): NotificationPreferenceListEntry {
    return NotificationPreferenceListEntryFromJSONTyped(json, false);
}

export function NotificationPreferenceListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPreferenceListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'mandatory_message': json['mandatory_message'] == null ? undefined : json['mandatory_message'],
        'channels': json['channels'] == null ? undefined : ((json['channels'] as Array<any>).map(NotificationChannelListEntryFromJSON)),
        'preference_settings': json['preference_settings'] == null ? undefined : NotificationPreferenceSettingsFromJSON(json['preference_settings']),
        'delivery_scopes': json['delivery_scopes'] == null ? undefined : ((json['delivery_scopes'] as Array<any>).map(NotificationPreferenceDeliveryScopeFromJSON)),
    };
}

export function NotificationPreferenceListEntryToJSON(json: any): NotificationPreferenceListEntry {
    return NotificationPreferenceListEntryToJSONTyped(json, false);
}

export function NotificationPreferenceListEntryToJSONTyped(value?: NotificationPreferenceListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'mandatory_message': value['mandatory_message'],
        'channels': value['channels'] == null ? undefined : ((value['channels'] as Array<any>).map(NotificationChannelListEntryToJSON)),
        'preference_settings': NotificationPreferenceSettingsToJSON(value['preference_settings']),
        'delivery_scopes': value['delivery_scopes'] == null ? undefined : ((value['delivery_scopes'] as Array<any>).map(NotificationPreferenceDeliveryScopeToJSON)),
    };
}

